module.exports = __webpack_public_path__ + "mea.1c843164e4525ed859eefc6ec6f9f58c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/mea.svg
// module id = 325
// module chunks = 0